import { useEffect, useState } from "react";
import { Gift } from "lucide-react";
import { fetchMyFidelite } from "@/lib/api";
import { fmtPrice } from "@/lib/utils";

export function FideliteBadge({ onAmount }) {
  const [fid, setFid] = useState(null);

  useEffect(() => {
    fetchMyFidelite().then((d) => { setFid(d); onAmount?.(d.montant_a_payer); }).catch(() => setFid(null));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!fid) return null;
  const pct = Math.min(100, Math.round((fid.nb_abonnements_payes / fid.seuil) * 100));

  if (fid.recompense_applicable) {
    return (
      <div className="rounded-2xl border-2 border-emerald-400 bg-emerald-50 p-4 mb-4 flex items-start gap-3" data-testid="fidelite-reward-banner">
        <Gift className="text-emerald-600 shrink-0 mt-0.5" size={20} />
        <div className="text-sm">
          <div className="font-bold text-emerald-800">Récompense fidélité débloquée : -{fid.reduction_pct}% !</div>
          <p className="text-emerald-900/80">Merci pour vos {fid.seuil} abonnements. Ce renouvellement vous coûte <b>{fmtPrice(fid.montant_a_payer)}</b> au lieu de {fmtPrice(fid.montant_plein)}. Appliqué automatiquement au paiement.</p>
        </div>
      </div>
    );
  }
  return (
    <div className="rounded-2xl border border-amber-200 bg-amber-50/70 p-4 mb-4" data-testid="fidelite-progress">
      <div className="flex items-center gap-2 text-sm font-semibold text-amber-800">
        <Gift size={16} /> Fidélité : plus que <span data-testid="fidelite-restants">{fid.restants}</span> abonnement{fid.restants > 1 ? "s" : ""} avant votre réduction de -{fid.reduction_pct}%
      </div>
      <div className="h-2 mt-2 rounded-full bg-amber-100 overflow-hidden">
        <div className="h-full bg-gradient-to-r from-amber-400 to-orange-500 transition-[width] duration-700" style={{ width: `${pct}%` }} />
      </div>
      <div className="text-[11px] text-amber-900/70 mt-1">{fid.nb_abonnements_payes}/{fid.seuil} abonnements payés plein tarif</div>
    </div>
  );
}
